package com.tovtalk.domain.entity

data class KosherLevel(
    val id: Int,
    val order: Int,
    val allowedOnHadran: Boolean,
    val requiresGenderVerification: Boolean,
    val nameKey: String,
    val descriptionKey: String?,
    val nameHe: String?,
    val nameEn: String?,
    val allowTextComments: Boolean,
    val allowEmojiReactions: Boolean,
)
